// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see FileSystemAlertLowDiskSpaceMessageEvent
 */
export var FileSystemAlertLowDiskSpaceMessage = function (_a) {
    var diskSpace = _a.diskSpace;
    return ({
        name: "FileSystem Alert LowDiskSpaceMessage",
        parameters: {
            cdf_entity: "FileSystem",
            cdf_action: "Alert",
            disk_space: diskSpace !== undefined && diskSpace !== null ? diskSpace.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
